import { render, staticRenderFns } from "./DialogAddLecturesLearningTrack.vue?vue&type=template&id=bbe27be2"
import script from "./DialogAddLecturesLearningTrack.vue?vue&type=script&lang=js"
export * from "./DialogAddLecturesLearningTrack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbe27be2')) {
      api.createRecord('bbe27be2', component.options)
    } else {
      api.reload('bbe27be2', component.options)
    }
    module.hot.accept("./DialogAddLecturesLearningTrack.vue?vue&type=template&id=bbe27be2", function () {
      api.rerender('bbe27be2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogAddLecturesLearningTrack.vue"
export default component.exports